
export default function VictoriaOverview() {
  const keyPoints = [
    {
      icon: 'ri-home-4-line',
      title: 'Principal Residence Only',
      description:
        'Victoria enforces BC\'s Provincial STR Act requiring principal residence where you live. You can rent your primary residence plus one secondary suite or ADU on the same property.'
    },
    {
      icon: 'ri-government-line',
      title: 'Provincial Registry Mandatory',
      description:
        'BC\'s 2026 Provincial Registry is fully active. All Victoria STRs must have a verified Provincial Registry Number. Platforms automatically de-list properties without valid registry numbers.'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Business License Required',
      description:
        'All STR operators must obtain a City of Victoria business license ($300 annual fee) and display both Provincial Registry Number and city license number on all listings.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Fire Safety Plan Required',
      description:
        'Properties must submit Fire Safety Plan with visual floor plan, certified fire extinguishers, government ID, and utility bills for verification.'
    }
  ];

  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <span className="inline-block bg-[#882629]/10 text-[#882629] px-4 py-2 rounded-full text-sm font-medium mb-4">
            Regulatory Overview
          </span>
          <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-[#505A5A] mb-6">
            Understanding Victoria&apos;s 2026 STR Framework
          </h2>
          <p className="text-lg text-[#505A5A]/70 leading-relaxed">
            Victoria enforces BC's Provincial Short-Term Rental Accommodations Act with strict principal residence requirements. The Provincial Registry is fully active in 2026, with platforms automatically de-listing non-compliant properties.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {keyPoints.map((point) => (
            <div
              key={point.title}
              className="bg-[#F8F8F8] rounded-2xl p-8 hover:shadow-lg transition-all"
            >
              <div className="w-14 h-14 bg-[#882629]/10 rounded-xl flex items-center justify-center mb-6">
                <i className={`${point.icon} text-2xl text-[#882629]`}></i>
              </div>
              <h3 className="text-xl font-semibold text-[#505A5A] mb-3">{point.title}</h3>
              <p className="text-[#505A5A]/70 leading-relaxed">{point.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-[#882629]/5 to-[#882629]/10 rounded-2xl p-8 lg:p-12">
          <div className="grid lg:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold text-[#882629] mb-2">$300</div>
              <p className="text-[#505A5A]/70">Annual License Fee</p>
            </div>
            <div>
              <div className="text-4xl font-bold text-[#882629] mb-2">365 Days</div>
              <p className="text-[#505A5A]/70">Max Rental Days (No Cap)</p>
            </div>
            <div>
              <div className="text-4xl font-bold text-[#882629] mb-2">$1,000+</div>
              <p className="text-[#505A5A]/70">Daily Violation Penalties</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
